<dx-form
    #workflowSubmitInvoiceEditor
    *ngIf="paymentEditor"
    width="100%"
    height="100%"
    class="submit-invoice-form"
    labelLocation="top"
    [colCount]="1"
    (onContentReady)="onSubmitFormContentReady()"
>
    <dxi-item [isRequired]="true">
        <dxo-label text="Community"></dxo-label>
        <div *dxTemplate>
            <app-multi-column-selector
                #communitySelector
                [name]="'Community'"
                [cssClass]="'field-component'"
                [disabled]="isCommunityContext || selectedCommunityId"
                [gridSource]="communityList"
                [boxValue]="communityGridBoxValue"
                [valueExpr]="'communityId'"
                [displayExpr]="'communityName'"
                [columnDef]="communityColumns"
                [dropDownButtonTemplate]="'dropDownButton'"
                [showClearButton]="true"
                [navigateToCommunity]="true"
                [placeholder]="'Select Community...'"
                [showHeaderFilters]="true"
                (gridSelectionEvent)="onCommunitySelection($event)"
            ></app-multi-column-selector>
        </div>
    </dxi-item>
    <dxi-item [isRequired]="true">
        <dxo-label text="Please select the Handling"></dxo-label>
        <div *dxTemplate>
            <dx-select-box
                #specialHandling
                displayExpr="displayText"
                valueExpr="specialHandlingId"
                [elementAttr]="{ class: 'field-component' }"
                [showClearButton]="true"
                [searchEnabled]="true"
                [disabled]="!communityId"
                [dataSource]="specialHandlingSource"
                [(value)]="paymentEditor.specialHandlingId"
                (onValueChanged)="onSpecialHandlingValueChange()"
            ></dx-select-box>
        </div>
    </dxi-item>
    <dxi-item [isRequired]="isNotesRequired">
        <dxo-label text="Notes / Special Instructions"></dxo-label>
        <div *dxTemplate>
            <dx-text-area class="textarea-input" [(value)]="paymentEditor.specialInstruction"></dx-text-area>
        </div>
    </dxi-item>
    <dxi-item itemType="group" [colCount]="3">
        <dxi-item [colSpan]="2">
            <dxo-label text="Invoice"></dxo-label>
            <div *dxTemplate>
                <dx-radio-group
                    valueExpr="key"
                    displayExpr="text"
                    [disabled]="!communityId"
                    [items]="invoiceOptions"
                    [(value)]="selectedInvoiceOption"
                    (onValueChanged)="onInvoiceOptionChanged()"
                ></dx-radio-group>
            </div>
        </dxi-item>
        <dxi-item>
            <div *dxTemplate class="fileuploader-container">
                <div class="invoice-uploader">
                    <div class="file-uploader-content dx-theme-border-color">
                        <div class="file-content">
                            {{ paymentEditor?.fileName }}
                        </div>
                        <div class="button-content">
                            <dx-button
                                type="danger"
                                stylingMode="text"
                                [icon]="iconTrash"
                                [visible]="paymentEditor?.fileName"
                                (onClick)="onDeleteFile()"
                            ></dx-button>
                        </div>
                        <div class="button-content">
                            <dx-button
                                type="default"
                                text="Browse"
                                hint="Browse"
                                (onClick)="onBrowseClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
                <dx-file-uploader
                    #fileUploader
                    labelText=""
                    accept="*"
                    uploadMode="useForm"
                    [visible]="false"
                    [multiple]="false"
                    [(value)]="uploadedFile"
                    (onValueChanged)="onFileUpload($event)"
                ></dx-file-uploader>
                <!-- </div> -->
            </div>
        </dxi-item>
    </dxi-item>
</dx-form>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowSubmitInvoiceEditor' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
